import * as Sentry from '@sentry/react';
import { createBrowserRouter, type PatchRoutesOnNavigationFunctionArgs } from 'react-router';

import { appRoutes } from './routes';

type CreateBrowserRouter = typeof createBrowserRouter;

export type AppRouter = ReturnType<CreateBrowserRouter>;

/**
 * Create the app router. Call this after `Sentry.init()` so
 * `wrapCreateBrowserRouterV7` instrumentation attaches correctly.
 */
export function createAppRouter(): AppRouter {
  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
  return sentryCreateBrowserRouter(appRoutes, {
    future: {
      v8_middleware: true,
    },
    async patchRoutesOnNavigation({ matches, patch }: PatchRoutesOnNavigationFunctionArgs) {
      const leafRoute = matches[matches.length - 1].route;
      if (leafRoute?.handle?.lazyChildren) {
        const lazyChildren = await leafRoute.handle.lazyChildren();
        patch(leafRoute.id ?? null, lazyChildren);
      }
    },
  });
}
